import { Check } from "lucide-react";
import { brl } from "@/lib/api";
import { moduleIcon, modulePrice, planModuleItems } from "@/lib/modules";
import { cn } from "@/lib/utils";

export function ModulePicker({ plan, catalog, value, onChange, testPrefix }) {
  const toggle = (m) => onChange(value.includes(m) ? value.filter((x) => x !== m) : [...value, m]);
  return (
    <div className="grid gap-2 sm:grid-cols-2" data-testid={`${testPrefix}-modules`}>
      {planModuleItems(plan.modules, catalog).map((m) => {
        const on = value.includes(m.id);
        const Icon = on ? Check : moduleIcon(m.id);
        return (
          <button key={m.id} type="button" onClick={() => toggle(m.id)} aria-pressed={on}
            className={cn("flex items-start gap-3 rounded-xl border p-3 text-left transition-colors duration-200", on ? "border-primary bg-primary/10" : "hover:border-primary/40")}
            data-testid={`${testPrefix}-module-${m.id}`}>
            <span className={cn("grid h-9 w-9 shrink-0 place-items-center rounded-lg transition-colors", on ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground")}><Icon className="h-4 w-4" /></span>
            <span className="min-w-0 flex-1">
              <span className="flex items-baseline justify-between gap-2">
                <b className="text-sm font-semibold">{m.label}</b>
                <span className="shrink-0 font-mono text-xs">{brl(modulePrice(plan, m.id))}<span className="text-muted-foreground">/mês</span></span>
              </span>
              {m.description && <span className="mt-0.5 block text-xs text-muted-foreground">{m.description}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
}
